/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as StarSvg } from "../../../resources/images/star.svg";

/* Styles */
import styles from "./styles";

const ConfirmRedemptionModal = ({
  showRedemptionModal,
  setShowRedemptionModal,
  pointsValue,
  redeemData,
  setAssignModalShow,
  allotmentId,
  onRedeemCompleted
}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <UCModal
      className={classes.confirmRedemptionModal}
      customStyle={classes.confirmRedemptionModalWrapper}
      showModal={showRedemptionModal}
      setShowModal={setShowRedemptionModal}
      modalIcon={<StarSvg />}
      modalTitle={<FormattedMessage id="confirmRedemptionModal.title" />}
      modalDescription={
        <FormattedMessage
          id="confirmRedemptionModal.description"
          values={{
            points: pointsValue.toLocaleString(),
          }}
        />
      }
      modalContent={
        <Content
          setShowModal={setShowRedemptionModal}
          redeemData={redeemData}
          setAssignModalShow={setAssignModalShow}
          allotmentId={allotmentId}
          onRedeemCompleted={onRedeemCompleted}
        />
      }
    />
  );
};

export default ConfirmRedemptionModal;
